import { Accessories } from "./_Accessories";
import { BasePage } from "@Tenants/Jm/Site/BasePage";
import { BaseProduct } from "@Base/Product/Product";

import "./Product.scss";

class Product extends BaseProduct
{
	public Accessories: Accessories;

	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		super.Initialize();

		this.Accessories = new Accessories();
	};
}

class ProductPage extends BasePage
{
	public Product: Product;
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Product = new Product();
	};
}

const product = new ProductPage();